import { useRequiredContext } from "@redotech/react-util/context";
import { useTriggerLoadAsync } from "@redotech/react-util/load";
import { toast } from "@redotech/redo-web/alert";
import { RedoMerchantRpcClientContext } from "./rpc-client";

/**
 * Trigger a file-downloads-engine report, emailed to the requesting user, with
 * consistent success/error toasts across export surfaces.
 */
export function useTriggerFileDownload(): {
  pending: boolean;
  triggerFileDownload: (input: {
    reportType: string;
    parameters?: unknown;
    successMessage: string;
    errorMessage: string;
  }) => Promise<void>;
} {
  const merchantRpcClient = useRequiredContext(RedoMerchantRpcClientContext);

  const [load, trigger] = useTriggerLoadAsync(
    async ({
      reportType,
      parameters,
      successMessage,
      errorMessage,
    }: {
      reportType: string;
      parameters?: unknown;
      successMessage: string;
      errorMessage: string;
    }) => {
      try {
        await merchantRpcClient.triggerFileDownload({
          reportType,
          parameters,
          sendEmail: true,
        });
        toast(successMessage, { variant: "success" });
      } catch (error) {
        console.error(`Failed to trigger ${reportType} download`, error);
        toast(errorMessage, { variant: "error" });
      }
    },
  );

  return { pending: load.pending, triggerFileDownload: trigger };
}
